import { TaskDetailsFragment } from '@/modules/tasks/views/TasksDashboard/graphql/queries/generated/taskDetails';

export const getIsEditTaskDisabled = (task: TaskDetailsFragment) => Boolean(task.provider);
